/**
 * Relay for Cart
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const CartPageQuery = graphql`
  query cart_Query {
    viewer{
      ...cart_viewer
    }
  }
`;

export const cartFragment = graphql`
  fragment cart_viewer on Viewer {
    selected_currency_rate
    cart{
      ...cartNode @relay(mask: false)
    }
    profile {
      ...profile @relay(mask: false)
    }
    selected_currency
  }
`;

export const CartNode = graphql`
  fragment cartNode on Cart {
    id
    license_line_items {
      ...licenseLineItem @relay(mask: false)
    }
    total
  }
`;

export const AddItemToCartMutation = graphql`
  mutation cartAddItem_Mutation($input: AddItemInput!) {
    addItem(input: $input) {
      cart{
        ...cartNode @relay(mask: false)
      }
    }
  }
`;

export const UpdateCartItemTermsMutation = graphql`
  mutation cartUpdateItem_Mutation($input: UpdateItemInput!) {
    updateItem(input: $input) {
      cart{
        ...cartNode @relay(mask: false)
      }
    }
  }
`;

export const DeleteItemFromCartMutation = graphql`
  mutation cartDeleteItem_Mutation($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      cart{
        ...cartNode @relay(mask: false)
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/cart.ts